// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

/* Set a background color /
body {
    background-color: #474e5d;
    font-family: Helvetica, sans-serif;
}*/

/* The actual timeline (the vertical ruler) */
.timeline {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
    content: '';
    position: absolute;
    width: 6px;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
}

/* Container around content */
.container {
    padding: 10px 40px;
    position: relative;
    background-color: inherit;
    width: 50%;
}

/* The circles on the timeline */
.container::after {
    content: '';
    position: absolute;
    width: 25px;
    height: 25px;
    right: -17px;
    background-color: white;
    border: 4px solid #FF9F55;
    top: 15px;
    border-radius: 50%;
    z-index: 1;
}

/* Place the container to the left */
.left {
    left: 0;
    animation: slideInFromLeft 0.3s ease-in-out;
}

/* Place the container to the right */
.right {
    left: 50%;
    animation: slideInFromRight 0.6s ease-in-out;
}

/* Add arrows to the left container (pointing right) */
.left::before {
    content: " ";
    height: 0;
    position: absolute;
    top: 22px;
    width: 0;
    z-index: 1;
    right: 30px;
    border: medium solid white;
    border-width: 10px 0 10px 10px;
    border-color: transparent transparent transparent white;
}

/* Add arrows to the right container (pointing left) */
.right::before {
    content: " ";
    height: 0;
    position: absolute;
    top: 22px;
    width: 0;
    z-index: 1;
    left: 30px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
}

/* Fix the circle for containers on the right side */
.right::after {
    left: -16px;
}

/* The actual content */
.content {
    padding: 20px 30px;
    background-color: white;
    position: relative;
    border-radius: 6px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
    /* Place the timelime to the left */
    .timeline::after {
        left: 31px;
    }

    /* Full-width containers */
    .container {
        width: 100%;
        padding-left: 70px;
        padding-right: 25px;
    }

    /* Make sure that all arrows are pointing leftwards */
    .container::before {
        left: 60px;
        border: medium solid white;
        border-width: 10px 10px 10px 0;
        border-color: transparent white transparent transparent;
    }

    /* Make sure all circles are at the same spot */
    .left::after, .right::after {
        left: 15px;
    }

    /* Make all right containers behave like the left ones */
    .right {
        left: 0%;
    }
}

@keyframes slideInFromLeft {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0);
    }
}

@keyframes slideInFromRight {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0);
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/timeline.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;;;;EAIE;;AAEF,6CAA6C;AAC7C;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,6CAA6C;AAC7C;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,MAAM;IACN,SAAS;IACT,SAAS;IACT,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;AACd;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA,oCAAoC;AACpC;IACI,OAAO;IACP,2CAA2C;AAC/C;;AAEA,qCAAqC;AACrC;IACI,SAAS;IACT,4CAA4C;AAChD;;AAEA,sDAAsD;AACtD;IACI,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,8BAA8B;IAC9B,uDAAuD;AAC3D;;AAEA,sDAAsD;AACtD;IACI,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,UAAU;IACV,0BAA0B;IAC1B,8BAA8B;IAC9B,uDAAuD;AAC3D;;AAEA,oDAAoD;AACpD;IACI,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,wEAAwE;AACxE;IACI,mCAAmC;IACnC;QACI,UAAU;IACd;;IAEA,0BAA0B;IAC1B;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA,qDAAqD;IACrD;QACI,UAAU;QACV,0BAA0B;QAC1B,8BAA8B;QAC9B,uDAAuD;IAC3D;;IAEA,+CAA+C;IAC/C;QACI,UAAU;IACd;;IAEA,wDAAwD;IACxD;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;MACE,4BAA4B;IAC9B;IACA;MACE,wBAAwB;IAC1B;AACJ;;AAEA;IACI;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\n/* Set a background color /\nbody {\n    background-color: #474e5d;\n    font-family: Helvetica, sans-serif;\n}*/\n\n/* The actual timeline (the vertical ruler) */\n.timeline {\n    position: relative;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n/* The actual timeline (the vertical ruler) */\n.timeline::after {\n    content: '';\n    position: absolute;\n    width: 6px;\n    background-color: white;\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    margin-left: -3px;\n}\n\n/* Container around content */\n.container {\n    padding: 10px 40px;\n    position: relative;\n    background-color: inherit;\n    width: 50%;\n}\n\n/* The circles on the timeline */\n.container::after {\n    content: '';\n    position: absolute;\n    width: 25px;\n    height: 25px;\n    right: -17px;\n    background-color: white;\n    border: 4px solid #FF9F55;\n    top: 15px;\n    border-radius: 50%;\n    z-index: 1;\n}\n\n/* Place the container to the left */\n.left {\n    left: 0;\n    animation: slideInFromLeft 0.3s ease-in-out;\n}\n\n/* Place the container to the right */\n.right {\n    left: 50%;\n    animation: slideInFromRight 0.6s ease-in-out;\n}\n\n/* Add arrows to the left container (pointing right) */\n.left::before {\n    content: \" \";\n    height: 0;\n    position: absolute;\n    top: 22px;\n    width: 0;\n    z-index: 1;\n    right: 30px;\n    border: medium solid white;\n    border-width: 10px 0 10px 10px;\n    border-color: transparent transparent transparent white;\n}\n\n/* Add arrows to the right container (pointing left) */\n.right::before {\n    content: \" \";\n    height: 0;\n    position: absolute;\n    top: 22px;\n    width: 0;\n    z-index: 1;\n    left: 30px;\n    border: medium solid white;\n    border-width: 10px 10px 10px 0;\n    border-color: transparent white transparent transparent;\n}\n\n/* Fix the circle for containers on the right side */\n.right::after {\n    left: -16px;\n}\n\n/* The actual content */\n.content {\n    padding: 20px 30px;\n    background-color: white;\n    position: relative;\n    border-radius: 6px;\n}\n\n/* Media queries - Responsive timeline on screens less than 600px wide */\n@media screen and (max-width: 600px) {\n    /* Place the timelime to the left */\n    .timeline::after {\n        left: 31px;\n    }\n\n    /* Full-width containers */\n    .container {\n        width: 100%;\n        padding-left: 70px;\n        padding-right: 25px;\n    }\n\n    /* Make sure that all arrows are pointing leftwards */\n    .container::before {\n        left: 60px;\n        border: medium solid white;\n        border-width: 10px 10px 10px 0;\n        border-color: transparent white transparent transparent;\n    }\n\n    /* Make sure all circles are at the same spot */\n    .left::after, .right::after {\n        left: 15px;\n    }\n\n    /* Make all right containers behave like the left ones */\n    .right {\n        left: 0%;\n    }\n}\n\n@keyframes slideInFromLeft {\n    0% {\n      transform: translateX(-100%);\n    }\n    100% {\n      transform: translateX(0);\n    }\n}\n\n@keyframes slideInFromRight {\n    0% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
